import { Box, Button, Typography, Grid } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../store/Index";

interface ColorPickerProps {
  value: string;
  onChange: (color: string) => void;
  label?: string;
  sx?: object;
}

const predefinedColors = ["#FFFFFF", "#000000", "#614338"];

const ColorPicker: React.FC<ColorPickerProps> = ({
  value,
  onChange,
  label = "Color",
  sx,
}) => {
  const isValidHex = (hex: string): boolean => {
    return /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(hex);
  };

  const handleSwatchClick = (color: string) => {
    onChange(color);
  };
  const reduxTheme = useSelector((state: RootState) => state.theme);

  return (
    <Box sx={{ ...sx }}>
      <Typography variant="subtitle2" gutterBottom>
        {label}
      </Typography>
      <Box display="flex" alignItems="center" gap={1} mb={2}>
        {/* Color preview box */}
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: "4px",
            border: `2px solid ${reduxTheme.grey_colors[700]}`,
            backgroundColor: isValidHex(value)
              ? value
              : reduxTheme.grey_colors[800],
            flexShrink: 0,
          }}
        />
      </Box>

      {/* Predefined color swatches */}
      <Typography variant="subtitle2" gutterBottom>
        Predefined Colors
      </Typography>
      <Grid container spacing={1}>
        {predefinedColors.map((color, index) => (
          <Grid key={index}>
            <Button
              variant="outlined"
              onClick={() => handleSwatchClick(color)}
              sx={{
                minWidth: 40,
                height: 40,
                borderRadius: 10,
                backgroundColor: color,
                borderColor:
                  value.toUpperCase() === color.toUpperCase()
                    ? reduxTheme.grey_colors[400]
                    : reduxTheme.grey_colors[700],
                borderWidth:
                  value.toUpperCase() === color.toUpperCase() ? "2px" : "1px",
                "&:hover": {
                  backgroundColor: color,
                  opacity: 0.8,
                  borderColor: reduxTheme.grey_colors[400],
                  borderWidth: "2px",
                },
                "&:active": {
                  transform: "scale(0.95)",
                },
              }}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ColorPicker;
